import moment from 'moment';
import { maskJs } from 'mask-js';

export const FormatDate = date => date ? moment(date).format('DD/MM/YYYY') : "";
export const FormatDateTime = date => date ? moment(date).format('DD/MM/YYYY HH:mm:ss') : "";
export const FormatCnpj = cnpj => cnpj ? maskJs('99.999.999/9999-99', cnpj) : '';
export const FormatPhone = phone => phone ? maskJs('(99) 9999?9-9999', phone) : '';
export const FormatMoney = v => {
	let val = (v / 1).toFixed(2).replace('.', ',')
	return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}
